module.exports = __webpack_public_path__ + "static/media/instagram-socials-social-media-icon-svgrepo-com.8d703c9a.svg";